module.exports = __webpack_public_path__ + "static/img/fruits_apple.21feefe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/fruits_apple.png
// module id = 7KQ6
// module chunks = 1